import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  ToggleButtonGroup,
  ToggleButton,
  Container,
  Tooltip,
  IconButton,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import InputField from "../FormFields/inputField";
import { fetchQuestionsByCalendar } from "../Services/Organisation.service";
import { useTranslation } from "react-i18next";
import LibraTranslate from "../LibreTransalate";
import './question.css'
const Questions = ({ values, setFieldValue, calendarObject }: any) => {
  const { t } = useTranslation();
  const [resident, setResident] = useState(true);
  const [calendarQuestions, setQuestions] = useState([]);

  useEffect(() => {
    if (calendarObject?.calendarid) {
      fetchQuestionByCalendar();
    }
  }, [calendarObject]);
  const fetchQuestionByCalendar = async () => {
    try {
      const response = await fetchQuestionsByCalendar(calendarObject?.calendarid);
      if (response) {
        setQuestions(response?.question);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const renderQuestionComponents = (questions: any[], values: any, setFieldValue: any) => {
    if (questions.length === 0) return null;

    const isQuestionVisible = (question: any) => {
      if (!question.dependsonquestionid) return true;
      const dependentQuestionValue = values.questionAnswers
        ? values.questionAnswers[question.dependsonquestionid]
        : null;
      return dependentQuestionValue?.toLowerCase() === question.dependsvalue?.toLowerCase();
    };

    return questions.map((question, index) => {
      if (!isQuestionVisible(question)) return null;

      switch (question.questiontype) {
        case "checkbox":
          return (
            <Box className="checkboxContainer" key={question.questionid} mb={"0.5rem"}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      (values.questionAnswers && values.questionAnswers[question.questionid]) ||
                      false
                    }
                    name={question.questionid}
                    onChange={(e: any) =>
                      setFieldValue("questionAnswers", {
                        ...values.questionAnswers,
                        [question.questionid]: e.target.checked,
                      })
                    }
                    className="inputField"
                  />
                }
                label={
                  <Typography className="checkboxLabel">
                    <LibraTranslate lang={"en"} text={question.question as string} />
                    
                    <span className="errorText">*</span>
                  </Typography>
                }
              />
            </Box>
          );
        case "multiple":
          return (
            <Box key={question.questionid} mb={"0.5rem"}>
              <Typography variant="body1" className="question">
              <LibraTranslate lang={"en"} text={question.question as string} />
                <span className="errorText">*</span>
              </Typography>
              <ToggleButtonGroup
                value={
                  (values.questionAnswers && values.questionAnswers[question.questionid]) || ""
                }
                exclusive
                onChange={(e: any, value) =>
                  setFieldValue("questionAnswers", {
                    ...values.questionAnswers,
                    [question.questionid]: value,
                  })
                }
                className="buttonGroup"
              >
                {["option1", "option2", "option3", "option4", "option5"].map(
                  (option) =>
                    question[option] && (
                      <ToggleButton
                        key={option}
                        value={question[option]}
                        color="primary"
                        name={question.questionid}
                      >
                        <LibraTranslate lang={"en"} text={question[option] as string} />
                      </ToggleButton>
                    )
                )}
              </ToggleButtonGroup>
            </Box>
          );
        case "textInput":
          return (
            <Box key={question.questionid} mb={"0.5rem"}>
              <Box className={'infoContainer'}>
                <Typography variant="body1" className="question">
                <LibraTranslate lang={"en"} text={question.question as string} />
                  <span className="errorText">*</span>
                </Typography>
                {question?.internallabel && (
                  <Tooltip title={question?.internallabel}>
                    <IconButton className={"infoIcon"}>
                      <InfoIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
              <InputField
                name={question.questionid}
                value={
                  (values.questionAnswers && values.questionAnswers[question.questionid]) || ""
                }
                fullWidth
                variant="outlined"
                className="inputField"
                onChange={(e: any) =>
                  setFieldValue("questionAnswers", {
                    ...values.questionAnswers,
                    [question.questionid]: e.target.value,
                  })
                }
              />
            </Box>
          );
        default:
          return null;
      }
    });
  };

  const totalMembers: any =
    values.bookingMemberTypes &&
    Object.values(values.bookingMemberTypes).reduce((acc: any, count: any) => acc + count, 0);

  return (
    <>
      {calendarQuestions && calendarQuestions?.length > 0 && totalMembers > 0 && (
        <Container className={"questionContainer"}>
          <Typography variant="h6" className={"question-heading"}>
            {t("Questions")}:
          </Typography>
          {renderQuestionComponents(
            calendarQuestions.filter((ob: any) => !ob.appliedtoguest),
            values,
            setFieldValue
          )}
          <Box className={"qacontainer"}>
            {calendarQuestions.filter((ob: any) => ob.appliedtoguest).length > 0 &&
              Array.from({ length: totalMembers }, (_, i) => (
                <>
                  <Box className={"header"}>
                    <Typography variant="h6" className={"headerText"}>
                      Individual #{i + 1}
                    </Typography>
                  </Box>
                  {renderQuestionComponents(
                    calendarQuestions
                      .filter((ob: any) => ob.appliedtoguest)
                      .map((ob: any) => ({
                        ...ob,
                        questionid: `${ob.questionid}:::::${i}`,
                      })),
                    values,
                    setFieldValue
                  )}
                </>
              ))}
          </Box>
        </Container>
      )}
    </>
  );
};

export default Questions;
